// extracted by mini-css-extract-plugin
export default {"leftArrowWrapperStyle":"styles_leftArrowWrapperStyle__131zK","arrowBtnStyle":"styles_arrowBtnStyle__knMAP","backArrowStyle":"styles_backArrowStyle__pdag0"};